import React from 'react';
import FeedItem from './FeedItem';

const FeedList = ({ 
  items = [], 
  onEdit, 
  onDelete, 
  onVideoPress, 
  className = "space-y-4",
  emptyMessage = "No content to display",
  loading = false,
  onLoadMore,
  hasMore = false
}) => {
  // Sort items by date (newest first)
  const sortedItems = [...items].sort((a, b) => {
    const dateA = a.content_type === 'game' ? new Date(a.date) : new Date(a.created_at);
    const dateB = b.content_type === 'game' ? new Date(b.date) : new Date(b.created_at);
    return dateB - dateA;
  });

  if (loading && items.length === 0) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!loading && items.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={className}>
      {sortedItems.map((item) => (
        <FeedItem
          key={`${item.content_type}-${item.id}`}
          item={item}
          onEdit={onEdit}
          onDelete={onDelete}
          onVideoPress={onVideoPress}
        />
      ))}
      
      {hasMore && (
        <div className="text-center py-4">
          <button
            onClick={onLoadMore}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default FeedList; 